import _ from 'lodash';
import React from 'react';

export function WidgetAccount ({ account }) {
    const number = _.padStart(account, 9, '0');

    return (<span>{number.substring(0, 2)}-{number.substring(2, 8)}-{number.substring(8)}</span>);
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    WidgetAccount.displayName = 'WidgetAccount';
}
